import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2m-1.275 13.096a3.75 3.75 0 0 0-3.75 3.75v.008A8.46 8.46 0 0 0 12 20.5a8.46 8.46 0 0 0 5.024-1.645v-.01a3.75 3.75 0 0 0-3.75-3.75zM12 3.5a8.5 8.5 0 0 0-6.38 14.114 5.25 5.25 0 0 1 5.105-4.018h2.55a5.25 5.25 0 0 1 5.103 4.02A8.5 8.5 0 0 0 12 3.5m-.001 2.25a3.519 3.519 0 1 1 0 7.037 3.519 3.519 0 0 1 0-7.037m0 1.5a2.018 2.018 0 1 0 0 4.036 2.018 2.018 0 0 0 0-4.036"
    }, null, -1)
  ]))]))
}
export default { render: render }